module.exports = __webpack_public_path__ + "static/media/farmers_market_stand_2.ea079ccb.jpeg";